export function visibleSceneSummary(summary: string) {
  const structured = summary.match(/(?:^|；)结果：([\s\S]*?)(?:；新增问题：[\s\S]*)?$/);
  return structured?.[1]?.trim() || summary;
}
